export const ADMISSION_VERIFY_ANSWERS_ROUTE = "/admission/verify";
